<template>
  <div>
    <h1>224 Blocks</h1>
    <h2>Running Efficiency</h2>
    <h1 style="font-size: 4rem;">{{ isFinite(runningEfficiency) ? runningEfficiency : "0.0" }}%</h1>
    <span>{{ totalBlocks }} / 224</span>
    <br />
    <br />
    <h2>Category Breakdown</h2>
    <div class="breakdowns">
      <table>
        <tr>
          <th>Category</th>
          <th class="percent">Quota</th>
          <th class="percent">|Blocks|</th>
          <th class="percent">Week</th>
        </tr>
        <tr v-for="category in categorySummaries">
          <td>
            <div class="block" :class="categories[category.id].color" />
            {{ categories[category.id].name }} ({{ category.count }})
          </td>
          <td class="percent">{{ Math.round((1000 * category.count) / category.quota) / 10 }}%</td>
          <td class="percent">{{ Math.round((1000 * category.count) / allBlocks.length) / 10 }}%</td>
          <td class="percent">{{ Math.round((1000 * category.count) / 224) / 10 }}%</td>
        </tr>
      </table>
    </div>
    <!-- <br>
      <br>
      <h2>Block Distribution</h2>
      <br/>
      <div v-for="block in allBlocks" 
        class="block"
        :class="categories[block.category].color"/> -->
    <!-- ADD WATCHER TO LOG DATA AND THEN SHOW A GRAPH OF HOW THIS IS CHANGING THROUGHOUT THE DAY -->
  </div>
</template>

<script>
import util from "../util.js";
import db from "../db.js";

export default {
  name: "realtime-view",
  props: ["categories", "days"],
  data() {
    return {
      now: new Date().getTime(),
    };
  },
  created() {
    //Load data for the previous days if it doesn't already exist
    db.getPast7Days();
    setInterval(() => {
      this.$data.now = Date.now();
    }, 60000);
  },
  computed: {
    runningEfficiency() {
      //FIXME - WE NEED TO TIMEOUT MAGIC HERE
      const potentialBlocks = 224;
      return Math.round((this.totalBlocks / potentialBlocks) * 10000) / 100;
    },
    totalBlocks() {
      const pastBlocks = this.pastWeek.length;
      let todayBlocks = this.todayBlocks.length;
      return pastBlocks + todayBlocks;
    },
    todayBlocks() {
      return Object.values(this.categories)
        .map(category => {
          return Object.values(category.blocks || {}).map(block => {
            return { ts: block.ts, category: category.id };
          });
        })
        .flat(2)
        .sort((a, b) => a.ts > b.ts);
    },
    allBlocks() {
      return [...this.pastWeek, ...this.todayBlocks];
    },
    cutoffTs() {
      return (
        moment(this.now)
          .subtract(7, "day")
          .unix() * 1000
      );
    },
    pastWeek() {
      return Object.values(this.days)
        .map(day => {
          return Object.keys(day).map(category => {
            return Object.values(day[category]).map(block => {
              return { ts: block.ts, category };
            });
          });
        })
        .flat(2)
        .sort((a, b) => {
          return a.ts > b.ts;
        })
        .filter(elem => {
          return elem.ts > this.cutoffTs;
        });
    },
    categorySummaries() {
      const counts = {};
      Object.values(this.allBlocks).forEach(block => {
        counts[block.category] = counts[block.category] ? counts[block.category] + 1 : 1;
      });
      return Object.keys(counts)
        .map(k => ({
          id: k,
          count: counts[k],
          quota: this.categories[k].quota * (this.categories[k].activeDays || []).length,
        }))
        .sort((a, b) => {
          return b.count - a.count;
        });
    },
  },
};
</script>

<style scoped>
.breakdowns {
  text-align: left;
  width: 400px;
  margin: 0 auto;
}

.breakdowns .block {
  margin: 0;
  position: relative;
  top: 0.125rem;
}

.percent {
  width: 75px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// RealtimeView.vue?11435f4c